/**
* @module actions/Spareparts
*/
import axios from 'axios'
import {
  API_URL,
  SET_SPARE_PARTS_ORDERING,
  SET_SPARE_PARTS_RECEPTION,
  SET_SPARE_PARTS_FOR_MATCHING
} from '../constants'

/**
* @description Getting simple list of suppliers from API
* @return {Promise} Axios promise
*/
export function getListSimple (filter) {
  let url = API_URL + '/Spareparts/Supplier/GetListSimple/' + filter
  return dispatch => {
    return axios.get(url)
  }
}

/**
* @description Getting supplier from API
* @return {Promise} Axios promise
*/
export function getSupplier (id) {
  let url = API_URL + '/Spareparts/Supplier/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
* @description Creating/saving a supplier
* @return {Promise} Axios promise
*/
export function createSaveSupplier (data) {
  let url = API_URL + '/Spareparts/Supplier/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

function getSparePartsPayload (data) {
  return {
    spareParts: data.SpareParts,
    comments: data.SparePartComments,
    filter: data.Filter
  }
}

/**
* @description Getting spareparts when ordering from API
* @return {Promise} Axios promise
*/
export function getSparePartsOrdering (filter) {
  let url = API_URL + '/Spareparts/ordering/'
  return dispatch => {
    return axios.post(url, filter).then(res => {
      dispatch({
        type: SET_SPARE_PARTS_ORDERING,
        payload: getSparePartsPayload(res.data)
      })

      return res
    })
  }
}

/**
* @description Creating a spare part
* @return {Promise} Axios promise
*/
export function createSparePart (data) {
  let url = API_URL + '/Spareparts/create'
  return dispatch => {
    return axios.post(url, data).then(res => {
      dispatch({
        type: SET_SPARE_PARTS_ORDERING,
        payload: getSparePartsPayload(res.data)
      })
    })
  }
}

/**
* @description Getting spareparts when receiving from API
* @return {Promise} Axios promise
*/
export function getSparePartsReception (filter) {
  let url = API_URL + '/Spareparts/reception/'
  return dispatch => {
    return axios.post(url, filter).then(res => {
      dispatch({
        type: SET_SPARE_PARTS_RECEPTION,
        payload: getSparePartsPayload(res.data)
      })
    })
  }
}

/**
* @description Getting spareparts when matching from API
* @return {Promise} Axios promise
*/
export function getSparePartsForMatching (filter) {
  let url = API_URL + '/Spareparts/getForMatching/'
  return dispatch => {
    return axios.post(url, filter).then(res => {
      dispatch({
        type: SET_SPARE_PARTS_FOR_MATCHING,
        payload: getSparePartsPayload(res.data)
      })
    })
  }
}

/**
* @description Update spareparts when ordering
* @return {Promise} Axios promise
*/
export function updateSparePartsOrdering (sparePartsBody) {
  let url = API_URL + '/Spareparts/updateOrdering'
  return dispatch => {
    return axios.post(url, sparePartsBody).then(res => {
      dispatch({
        type: SET_SPARE_PARTS_ORDERING,
        payload: getSparePartsPayload(res.data)
      })
      return res
    })
  }
}

/**
* @description Update spareparts when receiving
* @return {Promise} Axios promise
*/
export function updateSparePartsReception (sparePartsBody) {
  let url = API_URL + '/Spareparts/updateReception'
  return dispatch => {
    return axios.post(url, sparePartsBody).then(res => {
      dispatch({
        type: SET_SPARE_PARTS_RECEPTION,
        payload: getSparePartsPayload(res.data)
      })
    })
  }
}

/**
* @description Getting sparepart suppliers available to order from API
* @return {Promise} Axios promise
*/
export function getOrderingSparePartSuppliers (orderId, deliveryType) {
  let url = API_URL + '/Spareparts/ordering/GetSparePartSuppliers/' + orderId + '/' + deliveryType
  return dispatch => {
    return axios.get(url)
  }
}

/**
* @description Get details of an ordering sparepart
* @return {Promise} Axios promise
*/
export function getOrderingSparePartDetails (sparePart) {
  let url = API_URL + '/Spareparts/ordering/getSparePartDetails/'
  return dispatch => {
    return axios.post(url, sparePart)
  }
}

/**
* @description Get details of a reception sparepart
* @return {Promise} Axios promise
*/
export function getReceptionSparePartDetails (sparePart) {
  let url = API_URL + '/Spareparts/reception/getSparePartDetails/'
  return dispatch => {
    return axios.post(url, sparePart)
  }
}

/**
* @description Update supplier delivery setting
* @return {Promise} Axios promise
*/
export function updateSparePartDeliverySetting (setting) {
  let url = API_URL + '/Spareparts/Supplier/DeliverySettings/'
  return dispatch => {
    return axios.post(url, setting)
  }
}

/**
* @description Match two spare parts
* @return {Promise} Axios promise
*/
export function matchingSpareParts (sparePart) {
  let url = API_URL + '/Spareparts/matchingSpareParts/'
  return dispatch => {
    return axios.post(url, sparePart).then(res => {
      dispatch({
        type: SET_SPARE_PARTS_ORDERING,
        payload: getSparePartsPayload(res.data)
      })
      return res
    })
  }
}

/**
* @description Get filter details of ordering
* @return {Promise} Axios promise
*/
export function getFilterOrderingSparePartsDetails (filterDetails) {
  let url = API_URL + '/Spareparts/ordering/filterSparePartsDetails/'
  return dispatch => {
    return axios.post(url, filterDetails)
  }
}

/**
* @description Get filter details of reception
* @return {Promise} Axios promise
*/
export function getFilterReceptionSparePartsDetails (filterDetails) {
  let url = API_URL + '/Spareparts/reception/filterSparePartsDetails/'
  return dispatch => {
    return axios.post(url, filterDetails)
  }
}

/**
* @description Get list of spareparts for grouped list view
* @return {Promise} Axios promise
*/
export function getSparepartList (orderId) {
  let url = API_URL + '/Spareparts/list/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/spareparts.js